import axios from "axios";
import AxiosInstance from "../../AxiosInstance";

const loginApibasUrl = "/login";

// OTP Base URL (external PHP API – no token)
const OTP_BASE_URL = "http://13.203.147.59:81/ngpillai";

const LoginService = {

  // ERP Login (secured)
  Login: (details) => {
    return AxiosInstance.post(loginApibasUrl + "/Login", details);
  },

  // OTP Send (external PHP API – NO TOKEN)
  request_send_log: (pno, mail) => {
    return axios.get(
      `${OTP_BASE_URL}/send_email/index.php/request_send_log`,
      {
        params: { no: pno, mail: mail }
      }
    );
  },

  // Update Employee Password (Forgot / Reset)
  updateEmpPassword: (payload) => {
    return AxiosInstance.post(
      "http://13.203.147.59:8080/ng_spring_softwhare-0.0.1-SNAPSHOT/ngpillai/v1/ob/E_export/update_emp_password",
      payload
    );
  }

};

export default LoginService;
